// extracted by mini-css-extract-plugin
export default {"root":"Components_root__z38J0","row":"Components_row__w3cT8","heading":"Components_heading__nVlb0","loginButton":"Components_loginButton__0+Kja"};